module.exports = __webpack_public_path__ + "static/media/aifc-logo-white.e3346917.svg";